import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AssignmentStatus, TruckJourneyAssignmentLoad, TruckJourneyDelivery, TruckJourneyLoad } from '../../models/truck-journey.model';
import { Markers } from '../../../../shared/markers';
import { LocalLocationType } from '../../../../local-loads/shared/local-location-type';

@Component({
  selector: 'app-truck-journey-load',
  templateUrl: './truck-journey-load.component.html',
  styleUrls: ['./truck-journey-load.component.scss']
})
export class TruckJourneyLoadComponent {

  @Input() truckJourneyLoad: TruckJourneyAssignmentLoad | TruckJourneyLoad
  @Input() editableLoad: boolean
  @Input() deletableLoad: boolean
  @Input() isAssignmentLoad: boolean;

  @Output() onEditLoad: EventEmitter<void> = new EventEmitter<void>();
  @Output() onDeleteLoad: EventEmitter<void> = new EventEmitter<void>();

  protected readonly AssignmentStatus = AssignmentStatus;
  protected readonly LocalLocationType = LocalLocationType;
  public chepDepartureIconUrl = Markers.DEPARTURE_LOAD.chep
  public customerDepartureIconUrl = Markers.DEPARTURE_LOAD.customer;

  public editLoad(): void {
    this.onEditLoad.emit();
  }

  public getUniqueDeliveries(): TruckJourneyDelivery[] {
    const seen = new Set<string>();
    return this.truckJourneyLoad.stops
      .flatMap(stop => stop.deliveries)
      .filter(d => {
        if (seen.has(d.number)) return false;
        seen.add(d.number);
        return true;
      });
  }
}
